import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('div', {
    staticClass: "status-tabs"
  }, [_c('div', [_vm._v(_vm._s(_vm.t('中转退货状态')) + _vm._s(_vm.t('common', '：')))]), _c('a-tabs', {
    attrs: {
      "size": "small",
      "animated": false,
      "data-permission": "transition_return_search_status",
      "id": "transition_return_search_status"
    },
    on: {
      "change": _vm.handleTabChange
    },
    model: {
      value: _vm.searchData.return_status,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "return_status", $$v);
      },
      expression: "searchData.return_status"
    }
  }, [_c('a-tab-pane', {
    key: undefined,
    attrs: {
      "tab": _vm.t("全部 {0}", [_vm.searchData.return_status === undefined ? _vm.total !== null ? "(" + _vm.total + ")" : '' : ''])
    }
  }), _vm._l(_vm.ReturnStatusList, function (item) {
    return _c('a-tab-pane', {
      key: item.value,
      attrs: {
        "tab": _vm.searchData.return_status === item.value ? item.text + (_vm.total !== null ? "(" + _vm.total + ")" : '') : item.text
      }
    });
  })], 2)], 1), _c('my-enter-search', {
    staticClass: "mb-10",
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false
    },
    model: {
      value: _vm.searchData.code_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_type", $$v);
      },
      expression: "searchData.code_type"
    }
  }, _vm._l(_vm.transitionReturnListCodeTypeEnum, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "allowClear": "",
      "maxLength": 100
    },
    model: {
      value: _vm.searchData.code_value,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_value", $$v);
      },
      expression: "searchData.code_value"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u76EE\u7684\u4ED3"),
      "data-permission": "transition_return_warehouse_code",
      "id": "transition_return_warehouse_code",
      "show-tip": "",
      "placeholder": _vm.t('目的仓'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.warehouse_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "warehouse_code", $$v);
      },
      expression: "searchData.warehouse_code"
    }
  }, _vm._l(_vm.warehouseList, function (item) {
    return _c('a-select-option', {
      key: item.warehouse_code
    }, [_vm._v(_vm._s(item.warehouse_name_text))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u66F4\u65B0\u65F6\u95F4"),
      "allow-clear": false,
      "placeholder": _vm.t('更新时间')
    },
    model: {
      value: _vm.searchData.time_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "time_type", $$v);
      },
      expression: "searchData.time_type"
    }
  }, _vm._l(_vm.transitionReturnListTimeTypeEnum, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('my-range-picker', {
    attrs: {
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "format": "YYYY/MM/DD"
    },
    model: {
      value: _vm.datetimeDefaultValue,
      callback: function ($$v) {
        _vm.datetimeDefaultValue = $$v;
      },
      expression: "datetimeDefaultValue"
    }
  }, [_c('a-icon', {
    attrs: {
      "slot": "suffixIcon",
      "type": "calendar"
    },
    slot: "suffixIcon"
  })], 1)], 1), _c('span', {
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_c('a-button', {
    attrs: {
      "ghost": "",
      "data-sign": "transition_return_search",
      "type": "primary",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-sign": "transition_return_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "mb-15"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', ':')) + " " + _vm._s(_vm.selectedList.length))]), _c('a-dropdown', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'transition_return_export',
      expression: "'transition_return_export'"
    }]
  }, [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "transition_return_export_all",
      "id": "transition_return_export_all",
      "data-sign": "transition_return_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "transition_return_export_select",
      "id": "transition_return_export_select",
      "data-sign": "transition_return_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5BFC\u51FA")
    }
  }, [_vm._v(_vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1), _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'transition_return_add',
      expression: "'transition_return_add'"
    }],
    staticClass: "fr",
    attrs: {
      "data-permission": "transition_return_list_add",
      "id": "transition_return_list_add",
      "data-sign": "transition_return_list_add",
      "type": "primary",
      "fbu-analyse-name": $t("\u65B0\u589E")
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          name: 'AddTransitionReturn',
          params: {
            noCahce: '1'
          }
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.t('新增')))])], 1), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "columns": _vm.columns,
      "data-source": _vm.dataList,
      "fixed-header": "",
      "useMouseTool": "",
      "is-filter-box": "",
      "data-sign": "transition_return_list",
      "row-selection": _vm.rowSelection,
      "row-key": "return_code",
      "name": "transitionReturnList",
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "returnCode",
      fn: function (ref) {
        var record = ref.record;
        return [_c('router-link', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.return_code,
            expression: "record.return_code"
          }],
          attrs: {
            "to": {
              name: 'TransitionReturnDetailsPage',
              query: {
                code: record.return_code
              },
              params: {
                noCache: 1
              }
            },
            "data-sign": "transition_return_detail_redirect"
          }
        }, [_vm._v(_vm._s(record.return_code || '--'))])];
      }
    }, {
      key: "receiving_code",
      fn: function (ref) {
        var record = ref.record;
        return [_c('router-link', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.receiving_code,
            expression: "record.receiving_code"
          }],
          attrs: {
            "to": {
              name: 'DeliveryOrderDetailPage',
              query: {
                code: record.receiving_code,
                order_type: record.order_type,
                name: 'DeliveryOrderPage'
              },
              params: {
                noCache: 1
              }
            },
            "data-sign": "delivery_order_detail_redirect"
          }
        }, [_vm._v(_vm._s(_vm._f("filterEmpty")(record.receiving_code)))])];
      }
    }, {
      key: "warehouse",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_vm._v(" " + _vm._s(record['warehouse_code']) + "[" + _vm._s(record['warehouse_name']) + "] ")]);
      }
    }, {
      key: "return_quantity",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [record.order_type === _vm.$enum.intlCargo.OrderTypeEnum.TRANSIT ? _c('span', [_vm._v(" " + _vm._s(record['sku_type_num']) + _vm._s(_vm.t('SKU')) + _vm._s(_vm.t('共')) + _vm._s(record['sku_num']) + _vm._s(_vm.t('件')) + " ")]) : _vm._e(), _vm._v(" " + _vm._s(record['box_num']) + _vm._s(_vm.t('箱')) + " ")]);
      }
    }, {
      key: "return_status_text",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")(record.return_status_text)))]), record.return_status === _vm.$enum.warehouse.TransitionReturnStatusStatusEnum.REFUSE && record.reject_reason ? _c('a-popover', [_c('template', {
          slot: "content"
        }, [_c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")(record.reject_reason)))])]), _c('i', {
          staticClass: "ml-5 fa fa-exclamation-circle",
          staticStyle: {
            "color": "#ff8800 !important"
          }
        })], 2) : _vm._e()], 1);
      }
    }, {
      key: "remark",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [record.remark ? _c('text-ellipses', {
          attrs: {
            "max-width": 250,
            "data": record.remark
          }
        }) : _vm._e()], 1);
      }
    }, {
      key: "time",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [record['create_time'] ? _c('p', [_vm._v(_vm._s(_vm.t('创建')) + _vm._s(_vm.t('common', '：')) + _vm._s(record['create_time']))]) : _vm._e(), record['update_time'] ? _c('p', [_vm._v(_vm._s(_vm.t('更新')) + _vm._s(_vm.t('common', '：')) + _vm._s(record['update_time']))]) : _vm._e(), record['check_time'] ? _c('p', [_vm._v(_vm._s(_vm.t('审核')) + _vm._s(_vm.t('common', '：')) + _vm._s(record['check_time']))]) : _vm._e()]);
      }
    }])
  })], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "isFixed": "",
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "name": "transitionReturnList",
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };